import {Routes, RouterModule} from '@angular/router';

// Route for content layout with sidebar, navbar and footer.

export const Protected_ROUTES: Routes = [
  {
    path: 'rh',
    loadChildren: () => import('../../modulos/rh/rh.module').then(m => m.RhModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../modulos/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'personas',
    loadChildren: () => import('../../modulos/personas/personas.module').then(m => m.PersonasModule)
  },
  {
    path: 'facturacion',
    loadChildren: () => import('../../modulos/cxc/facturacion/facturacion.module').then(m => m.FacturacionModule)
  },
  {
    path: 'cxc',
    loadChildren: () => import('../../modulos/cxc/pagos/pagos-cxc.module').then(m => m.PagosCxcModule)
  },
  {
    path: 'patrimonios',
    loadChildren: () => import('../../modulos/legal/patrimonios/patrimonios.module').then(m => m.PatrimoniosModule)
  },
  {
    path: 'prediales',
    loadChildren: () => import('../../modulos/legal/prediales/prediales.module').then(m => m.PredialesModule)
  },
  {
    path: 'seguros',
    loadChildren: () => import('../../modulos/legal/seguros/seguros.module').then(m => m.SegurosModule)
  },
  {
    path: 'licencias',
    loadChildren: () => import('../../modulos/legal/licencias/licencias.module').then(m => m.LicenciasModule)
  },
  {
    path: 'proveedores',
    loadChildren: () => import('../../modulos/cxp/proveedores/proveedores.module').then(m => m.ProveedoresModule)
  },
  {
    path: 'requisiciones',
    loadChildren: () => import('../../modulos/cxp/requisiciones/requisiciones.module').then(m => m.RequisicionesModule)
  },
  {
    path: 'facturacion-cxp',
    loadChildren: () => import('../../modulos/cxp/facturacion/facturacioncxp.module').then(m => m.FacturacioncxpModule)
  },
  {
    path: 'pagos-cxp',
    loadChildren: () => import('../../modulos/cxp/pagos/pagos.module').then(m => m.PagosModule)
  },
  {
    path: 'contabilidad',
    loadChildren: () => import('../../modulos/contabilidad/contabilidad.module').then(m => m.ContabilidadModule)
  },
  {
    path: 'graficos',
    loadChildren: () => import('../../modulos/graficos/graficos.module').then(m => m.GraficosModule)
  },
  {
    path: 'comprobacion-gastos',
    loadChildren: () => import('../../modulos/comprobacion-gastos/comprobacion-gastos.module').then(m => m.ComprobacionGastosModule)
  },
  {
    path: 'administracion',
    loadChildren: () => import('../../modulos/usuario/usuario.module').then(m => m.UsuarioModule)
  },
  {
    path: 'utileria',
    loadChildren: () => import('../../modulos/utileria/utileria.module').then(m => m.UtileriaModule)
  }

];
